import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveObject, resolve } from '../../Container';
import { FeatureManager } from '../feature/FeatureManager';
import { CallWidget } from './CallWidget';

export class CallMechanics extends ActiveObject {

    @resolve(FeatureManager) private features!: FeatureManager;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start = () => {
        this.features.define('Calls', this.realizeCallWidget);
    };

    private realizeCallWidget = (enabled: boolean) => {
        const { widgets } = this;
        widgets.delete('call');
        if (!enabled) return;
        const dock = widgets.createContainer({
            name: 'call',
            style: 'none',
            weight: 100,
            position: ['docked', 'bottomRight', 'inline'],
        });
        dock.add(widgets.createInline({ ui: CallWidget }));
        widgets.add(dock);
    };
}
